<template>
	<PageLoading :is-loading="isLoading"></PageLoading>
	<SideComponent @scrollto="scroll"></SideComponent>
	<div class="container" ref="viewBox">
		<div class="header-container">
			<div class="search-swiper-container">				
				<Swiper :list="banners"/>
				<!-- <search-bar-pic :isNeedRedirect="false" @searchKeywords="fetchGrapher"></search-bar-pic> -->
			</div>
		</div>
		<div class="content">
			<div class="wrapper">
				<!-- <div style="font-family: 黑体, SimHei; font-size: 14px;color:#9b9b9b;margin:12px 0;" v-if="views > 0 || activityDetail.id">
					<span>{{$t('contentViews')}} {{views}}</span>
				</div> -->
				<div class="tab-wrapper">
					<div class="tab-left">
						<div class="tab-item" v-for="item in tags" @click="switchTag(item)"><span :class="tagStyle(item)">{{item.name}}</span></div>
					</div>
					<div class="tab-right" v-if="canUpload">
						<div class="upload-btn" @click="toUpload()">{{$t('active.upload')}}</div>
					</div>
					<div class="tab-right tab-right--closed" v-else-if="uploadClosedTip">
						<span class="upload-closed-tip">{{ uploadClosedTip }}</span>
					</div>
				</div>
				<div class="activity-related" v-if="showRelated">
					<div class="content-tabs" v-if="showRelatedTabs">
						<button
							v-if="showRelatedNews"
							type="button"
							class="content-tabs__item"
							:class="{ 'content-tabs__item--active': relatedActiveTab === 'news' || !showRelatedVisual }"
							@click="switchRelatedTab('news')"
						>资讯</button>
						<button
							v-if="showRelatedVisual"
							type="button"
							class="content-tabs__item"
							:class="{ 'content-tabs__item--active': relatedActiveTab === 'visual' || !showRelatedNews }"
							@click="switchRelatedTab('visual')"
						>视觉</button>
					</div>

					<div class="enclosure" v-show="showRelatedNews && relatedActiveTab === 'news'">
						<section class="section" v-if="relatedNewsList.length>0">
							<Loading :is-loading="isRelatedNewsLoading"></Loading>
							<div class="_1Aw4E" @click="toRelated(item.id, item.link)" v-for="item in relatedNewsList" :key="'news-'+item.id">
								<a class="img">
									<img :src="item.thumb"/>
									<span class="category-name" v-html="item.title"></span>
								</a>
							</div>
						</section>
						<div class="loadmore">
							<span class="more" @click="loadMoreRelatedNews()" v-if="!relatedNewsNomore && !isRelatedNewsLoading">{{$t('loadmore')}}</span>
							<span class="end" v-if="relatedNewsNomore && !isRelatedNewsLoading && relatedNewsList.length">- {{$t('theEnd')}} -</span>
						</div>
					</div>

					<div class="enclosure" v-show="showRelatedVisual && relatedActiveTab === 'visual'">
						<section class="section masonry" v-if="relatedVideoList.length>0">
							<Loading :is-loading="isRelatedVideoLoading"></Loading>
							<div class="masonry-column" v-for="(column, colIndex) in relatedVideoColumns" :key="'col-'+colIndex">
								<div class="_1Aw4E related-video-item" v-for="item in column" :key="'video-'+item.id">
									<div @click="toRelated(item.id, item.link)" style="width:100%;">
										<video v-if="isMobile"
											:poster="item.thumb"
											preload="none"
											muted=""
											:alt="item.title"
											:style="getRelatedVideoAspectStyle(item)"
											controlslist="nodownload"
											oncontextmenu="return false">
											<track kind="captions" />
											<source :src="item.video" type="video/mp4">
										</video>
										<video v-if="!isMobile"
											controls
											:poster="item.thumb"
											preload="none"
											muted=""
											:alt="item.title"
											:style="getRelatedVideoAspectStyle(item)"
											controlslist="nodownload"
											oncontextmenu="return false"
											:src="item.video"
											@click.stop>
											<track kind="captions" />
										</video>
									</div>
									<div class="video_name" @click="toRelated(item.id, item.link)">
										<span v-html="item.title"></span>
									</div>
								</div>
							</div>
						</section>
						<div class="loadmore">
							<span class="more" @click="loadMoreRelatedVideos()" v-if="!relatedVideoNomore && !isRelatedVideoLoading">{{$t('loadmore')}}</span>
							<span class="end" v-if="relatedVideoNomore && !isRelatedVideoLoading && relatedVideoList.length">- {{$t('theEnd')}} -</span>
						</div>
					</div>
				</div>
				<div class="pic-video-list container-width" v-if="showRevelation">
					<div id="revelation-content" v-html="activityDetail.content" style="text-align: justify;"></div>
				</div>
				<div class="pic-video-list" v-if="showList">
					<div class="item-wrapper" v-if="showList && picList.length>0">
						<div class="head">{{$t('active.pic')}}</div>
						<div class="body">
							<Loading :is-loading="isPicLoading"></Loading>
							
							<div class="img-item" v-for="item in picList" :style="activeStyle(item)" @click.stop="toPicDetail(item.id)">					
								<img class="img" :src="item.thumb"  oncontextmenu="return false" :alt="item.title"/>
						  		<div class="title">
						  			<span v-html="item.title"></span>
						  		</div>						
							</div>
							
						</div>
						<div class="loadmore">
							<span class="more" @click="loadMorePics()" v-if="!picNomore">{{$t('loadmore')}}</span>
							<span class="end" v-if="picNomore">- {{$t('theEnd')}} -</span>
						</div>
					</div>
					<div style="height:50px;width:100%;"></div>
					<div class="item-wrapper" v-if="showList && videoList.length>0">
						<div class="head">{{$t('active.video')}}</div>
						<div class="body">
							<Loading :is-loading="isVideoLoading"></Loading>
							
							<div class="img-item" v-for="item in videoList" :style="activeStyle(item)" @click.stop="toVideoDetail(item.id)">						
								<video v-if="!isMobile"
								    controls								
								    :poster="item.thumb" 
								    preload="none" 
								    muted 
								    style="object-fit:cover;width:100%;height:100%;border-radius: 8px;" 
								    controlslist="nodownload" 
								    oncontextmenu="return false"
								    :src="item.url"
								     :alt="item.title"
								    >
									<track kind="captions" />
								</video>
								<video v-if="isMobile"								
								    :poster="item.thumb" 
								    preload="none" 
								    muted 
								    :alt="item.title" 
								    style="object-fit:cover;width:100%;height:100%;border-radius: 8px;" 
								    controlslist="nodownload" 
								    oncontextmenu="return false"
							    	
							    >
								<track kind="captions" />
								<source :src="item.url" type="video/mp4">
							</video>
						  		<div class="title">
						  			<span v-html="item.title"></span>
						  		</div>						
							</div>
							
						</div>
						<div class="loadmore">
							<span class="more" @click="loadMoreVideos()" v-if="!videoNomore">{{$t('loadmore')}}</span>
							<span class="end" v-if="videoNomore">- {{$t('theEnd')}} -</span>
						</div>
					</div>
				</div>


				<div class="pic-video-list container-width" v-if="showExcellent">
					<div id="giftwork-content" class="html-content" v-html="activityDetail.giftwork" style="text-align: justify;"></div>
				</div>

				
				
			</div>
			
		</div>
		<Footer/>

	</div>
</template>

<script>
	import active from './active_controller';
	export default active;
</script>

<style src="@/assets/css/active.css" scoped>
	/*@import url("@/assets/css/style.css");全局引用css*/
	/*@import '@/assets/css/style.css';*/
</style>
<style>
	#revelation-content p img{
		width:86%!important;
		/*max-width:800px;*/
		object-fit: contain;
		height:auto!important;
	}
	@media screen and (max-width: 767px) {
		#revelation-content p img{
			width:90%!important;
			max-width:375px!important;
		}
	}
	#giftwork-content.html-content img {
		width: auto !important;
		max-width: 800px !important;
		height: auto !important;
		object-fit: contain;
	}
	@media screen and (max-width: 767px) {
		#giftwork-content.html-content img {
			width: auto !important;
			max-width: 100% !important;
			height: auto !important;
		}
	}
	.activity-related .content-tabs {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		gap: 8px;
		padding: 8px 10px 0;
		width: 100%;
		box-sizing: border-box;
	}
	.activity-related .content-tabs__item {
		height: 36px;
		padding: 0 18px;
		border: 0;
		border-radius: 5px;
		background: #fff;
		color: #000;
		font-size: 16px;
		cursor: pointer;
		box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.08);
	}
	.activity-related .content-tabs__item--active {
		background: rgba(223, 58, 8, 1);
		color: #fff;
	}
	.activity-related .enclosure .section.masonry {
		display: flex;
		align-items: flex-start;
		justify-content: flex-start;
		flex-wrap: nowrap;
		gap: 0;
	}
	.activity-related .masonry-column {
		flex: 1;
		min-width: 0;
	}
	.activity-related .enclosure .section.masonry ._1Aw4E {
		width: 100%;
		height: auto;
		padding: 8px;
	}
	.activity-related .enclosure .section.masonry ._1Aw4E .video_name {
		margin-top: 8px;
		font-size: 14px;
		line-height: 1.4;
		color: #333;
	}
	@media screen and (max-width: 767px) {
		.activity-related .enclosure .section.masonry {
			flex-direction: column;
		}
	}
</style>